import { Flex } from './flex'
import { Grid } from './grid'
import { Input } from './input'
import { Textarea } from './textarea'
import { Card } from './card'
import { Button } from './button'
import { ToolTip } from './tooltip'
import { Divider } from './divider'
import { Badge } from './badge'
import { Loader } from './loader'
import { Empty } from './empty'
import { Pagination } from './pagination'
import { Modal } from './modal'
import { Drawer } from './drawer'
import { Checkbox } from './checkbox'
import { TabContainer, TabItem } from './tab'
import { Toogle } from './toogle'
import { Container } from './container'
import { TableContainer, TableHeader, TableContent, TableRow, TableRowCheckBox } from './table'

const Table = {
    Container: TableContainer,
    Header: TableHeader,
    Content: TableContent,
    Row: TableRow,
    RowCheckBox: TableRowCheckBox,
}

const Tab = {
    Container: TabContainer,
    Item: TabItem
}


export {
    Modal, Drawer, Card, Container,
    Input, Textarea, Button, Checkbox, Table, Pagination, Tab, Toogle,
    Flex, Grid, ToolTip, Divider, Badge, Loader, Empty
}